import { FilterableTable } from "components/FilterableTable";
import { claimsTableColumn } from "./config";
import React from "react";
import apiService from "services/api";
import { useState } from "react";
import { centreOptions } from "constants";

const defaultFilters = [
	{
		filterName: "date_from",
		operator: "contains",
		placeholder: "Date",
		type: "date",
		label: "Date From",
	},
	{
		filterName: "date_to",
		operator: "contains",
		placeholder: "Date",
		type: "date",
		label: "Date To",
	},
	{
		filterName: "claim_id",
		operator: "contains",
		placeholder: "Claim ID",
		type: "text",
		label: "Claim ID",
	},
	{ filterName: "staff_name", operator: "contains", placeholder: "Staff Name" },
	{
		filterName: "status",
		operator: "contains",
		label: "Status",
		type: "select",
		options: [
			{ value: null, label: "All" },
			{ value: "pending", label: "Pending" },
			{ value: "approved", label: "Approved" },
			{ value: "rejected", label: "Rejected" },
			{ value: "paid", label: "Paid" },
		],
	},
	{
		filterName: "centre",
		operator: "contains",
		label: "Centre",
		type: "select",
		options: [{ value: null, label: "All" }, ...centreOptions],
	},
	{
		filterName: "is_petty_cash",
		operator: "contains",
		label: "Claim Type",
		type: "select",
		options: [
			{ value: null, label: "All" },
			{ value: true, label: "Petty Cash" },
			{ value: false, label: "Cheque" },
		],
	},
	{
		filterName: "company",
		operator: "contains",
		label: "Company",
		type: "select",
		options: [
			{ value: null, label: "All" },
			{ value: "G", label: "Genius" },
			{ value: "S", label: "Scientech" },
		],
	},
	{
		filterName: "claim_period",
		operator: "contains",
		label: "Claim Period",
		type: "select",
		options: [
			{ value: null, label: "All" },
			{ value: "current", label: "Current Month" },
			{ value: "last", label: "Last Month" },
		],
	},
];
export const ClaimsTable = ({ self, showModal, parentRefetchCheck, title, filters = defaultFilters }) => {
	const [refetchCheck, setRefetchCheck] = useState(false);

	React.useEffect(() => {
		setRefetchCheck((prev) => !prev);
	}, [parentRefetchCheck]);

	return (
		<>
			<FilterableTable
				query={(filters) => () => self ? apiService.staff.claims.self(filters) : apiService.staff.claims.get(undefined, {}, filters)}
				title={title || (self ? "My Claims" : "All Claims")}
				actionPrepend
				queryKey={self ? ["claims", "self"] : ["claims", "all"]}
				columns={claimsTableColumn}
				refetchCheck={refetchCheck}
				filters={filters}
			/>
		</>
	);
};
